import { Component, OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./facilities.component.scss']
})

export class ProjectComponent extends SeoAwareBaseComponent implements OnInit {
  public reasons: any[] = [];
  translateSubscription: Subscription = new Subscription();
  subscription: Subscription = new Subscription();

  constructor(
    public injector: Injector,
    public translateService: TranslateService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.meta.addTags([
      { name: 'robots', content: 'noindex' }
    ]);
    this.setTitle('Despre proiect');
  }
}



// WEBPACK FOOTER //
// ./src/app/about-us/project.component.ts